import { Link } from "react-router-dom";
import { Coins, Headphones } from "lucide-react";
import CoverImage from "./CoverImage";

export default function StoryCard({ story, featured }) {
  return (
    <Link
      to={`/story/${story.id}`}
      data-testid={`story-card-${story.id}`}
      className={`group block animate-fade-up ${featured ? "sm:col-span-2 sm:row-span-2" : ""}`}
    >
      <div className={`relative overflow-hidden rounded-lg bg-secondary ${featured ? "aspect-[16/10]" : "aspect-square"}`}>
        {story.cover_url ? (
          <CoverImage
            coverUrl={story.cover_url}
            alt={story.title}
            data-testid={`story-cover-${story.id}`}
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105 group-hover:brightness-110"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-muted-foreground">
            <Headphones size={32} strokeWidth={1.5} />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="uppercase tracking-[0.15em] text-[10px] bg-black/50 backdrop-blur px-2 py-1 rounded text-foreground/90">
            {story.category}
          </span>
          {story.mature && (
            <span className="uppercase tracking-[0.15em] text-[10px] bg-primary/80 px-2 py-1 rounded">18+</span>
          )}
        </div>
        {featured && (
          <div className="absolute bottom-4 left-4 right-4">
            <h3 className="font-display text-2xl leading-tight mb-1">{story.title}</h3>
            <p className="text-sm text-foreground/70 line-clamp-2">{story.description}</p>
          </div>
        )}
      </div>
      {!featured && (
        <div className="mt-3">
          <h3 className="font-display text-lg leading-tight truncate">{story.title}</h3>
          <div className="flex items-center justify-between mt-1">
            <span className="text-xs text-muted-foreground truncate">{story.creator_name || story.language}</span>
            <span className="flex items-center gap-1 text-xs text-muted-foreground">
              <Headphones size={12} strokeWidth={1.5} /> {story.episode_count}
            </span>
          </div>
        </div>
      )}
    </Link>
  );
}
